import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, HelpCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const faqs = [
  {
    q: 'Was kostet die Nutzung des WEG-Analysetools?',
    a: 'Die Nutzung ist vollständig kostenfrei — sowohl die Analyse als auch die Registrierung und PDF-Erstellung. Es gibt keine versteckten Kosten oder kostenpflichtige Funktionen.',
  },
  {
    q: 'Muss ich mich registrieren, um eine Analyse durchzuführen?',
    a: 'Nein, eine Registrierung ist nicht erforderlich. Sie können direkt eine Analyse starten. Wenn Sie sich jedoch registrieren, können Sie Ihre Analysen dauerhaft speichern und PDF-Dokumente mit Ihrem eigenen Firmennamen erstellen.',
  },
  {
    q: 'Welche Daten werden bei der Analyse erhoben?',
    a: 'Es werden ausschließlich Objektdaten erfasst: Adresse, Gebäudedaten (Baujahr, Einheiten, Etagen), Zustand, Ausstattung und Verwaltungshistorie. Personenbezogene Daten werden nur bei einer Registrierung erhoben (Name, E-Mail).',
  },
  {
    q: 'Wie lange werden meine Daten gespeichert?',
    a: 'Analysen, die ohne Registrierung erstellt werden, werden dauerhaft gespeichert und sind über den Analyse-Link abrufbar. Registrierte Nutzer können ihre Daten jederzeit in ihrem Profil exportieren oder löschen.',
  },
  {
    q: 'Wie sicher sind meine Daten?',
    a: 'Alle Verbindungen sind TLS/SSL-verschlüsselt (HTTPS). Passwörter werden mit bcrypt gehasht. Die Authentifizierung erfolgt über signierte JWT-Tokens. Detaillierte Informationen finden Sie auf unserer Seite "Sicherheit & Datenschutz".',
  },
  {
    q: 'Kann ich meine Daten löschen lassen?',
    a: 'Ja, gemäß DSGVO können Sie jederzeit in Ihrem Nutzerprofil alle Daten als JSON exportieren oder Ihr Konto inklusive aller Analysedaten unwiderruflich löschen.',
  },
  {
    q: 'Wie wird der Verwaltungsbedarf berechnet?',
    a: 'Der Verwaltungsbedarf wird anhand von drei Kategorien ermittelt: Gebäudekomplexität (Größe, Ausstattung, besondere Merkmale), Gebäudezustand (Renovierungsbedarf, energetischer Zustand) und Verwaltungshistorie (Eigentümerwechsel, Rechtsstreitigkeiten, Zahlungsverhalten). Die Gewichtung der einzelnen Kategorien ist konfigurierbar.',
  },
  {
    q: 'Was bedeuten die Bewertungsstufen?',
    a: 'Der Verwaltungsbedarf wird in Stufen eingeteilt (z.B. "Unterdurchschnittlich", "Durchschnittlich", "Überdurchschnittlich"). Diese Stufen dienen als Orientierung für den zu erwartenden Verwaltungsaufwand und werden in den PDF-Dokumenten visualisiert.',
  },
  {
    q: 'Kann ich den Firmennamen in den PDFs anpassen?',
    a: 'Ja, als registrierter Nutzer können Sie unter "PDF-Firmenname" Ihren eigenen Firmennamen hinterlegen. Dieser wird dann in allen generierten PDFs anstelle des Standard-Firmennamens angezeigt. Die Funktion kann jederzeit aktiviert oder deaktiviert werden.',
  },
  {
    q: 'Werden Cookies verwendet?',
    a: 'Wir verwenden nur technisch notwendige Cookies für die Authentifizierung (Login-Token). Es werden keine Tracking- oder Marketing-Cookies eingesetzt. Detaillierte Informationen finden Sie in unserer Datenschutzerklärung.',
  },
];

export default function FaqPage() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-6 animate-fade-in" data-testid="faq-page">
      <div className="flex items-center gap-3 mb-8">
        <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <HelpCircle className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Häufig gestellte Fragen</h1>
          <p className="text-sm text-muted-foreground">Alles Wichtige zum WEG-Analysesystem</p>
        </div>
      </div>

      <Card>
        <CardContent className="p-6">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`faq-${i}`}>
                <AccordionTrigger className="text-sm text-left font-medium" data-testid={`faq-q-${i}`}>
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-muted-foreground leading-relaxed">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </CardContent>
      </Card>

      <Separator className="my-8" />
      <div className="text-center">
        <Link to="/">
          <Button variant="outline" size="sm" className="gap-2" data-testid="faq-back-btn">
            <ArrowLeft className="h-3.5 w-3.5" /> Zur Startseite
          </Button>
        </Link>
      </div>
    </div>
  );
}
